import { requestFormPost } from '@/common/request';

export default {
  /* ****************列表相关**************** */
  // 会场收品-会场收品-根据条件分页获取活动信息【活动列表相关】
  async fetchActivityPage(data) {
    return await requestFormPost('/generic/mac/yx/activity/page', data);
  },

  // 会场收品-会场收品-前端异步获取活动扩展信息【活动列表相关】
  async fetchActivityExtFields(data) {
    return await requestFormPost('/generic/mac/yx/activity/extFields', data);
  },

  // 会场收品-会场收品-根据条件分页获取区块信息【收品池列表相关】
  async fetchAreaPage(data) {
    return await requestFormPost('/generic/mac/yx/area/page', data);
  },

  // 会场收品-会场收品-前端异步获取区块扩展信息【收品池列表相关】
  async fetchAreaExtFields(data) {
    return await requestFormPost('/generic/mac/yx/area/extFields', data);
  },

  /* ****************分组相关+收藏相关**************** */
  // 会场收品-会场收品-查询用户的所有分组【分组相关+收藏相关】
  async fetchaActivityCollectionAll(data) {
    return await requestFormPost('/generic/mac/activity/collection/all', data);
  },

  // 会场收品-会场收品-查询活动所属分组(不包括我的关注)【分组相关+收藏相关】
  async fetchaActivityCollectionGetgroup(data) {
    return await requestFormPost('/generic/mac/activity/collection/getgroup', data);
  },

  // 会场收品-会场收品-判断活动id是否已关注【只是我的分组】【分组相关+收藏相关】
  async fetchaActivityWatchIsWatch(data) {
    return await requestFormPost('/generic/mac/activity/watch/isWatch', data);
  },

  // 会场收品-会场收品-添加分组【分组相关+收藏相关】
  async fetchaActivityCollectionAdd(data) {
    return await requestFormPost('/generic/mac/activity/collection/add', data);
  },

  // 会场收品-会场收品-修改分组【分组相关+收藏相关】
  async fetchaActivityCollectionMod(data) {
    return await requestFormPost('/generic/mac/activity/collection/mod', data);
  },

  // 会场收品-会场收品-删除分组【分组相关+收藏相关】
  async fetchaActivityCollectionDel(data) {
    return await requestFormPost('/generic/mac/activity/collection/del', data);
  },

  // 会场收品-会场收品-添加活动到分组【分组相关+收藏相关】
  async fetchaActivityCollectionSetgroup(data) {
    return await requestFormPost('/generic/mac/activity/collection/setgroup', data);
  },

  // 会场收品-会场收品-新增对活动的关注【分组相关+收藏相关】
  async fetchaActivityWatchCreate(data) {
    return await requestFormPost('/generic/mac/activity/watch/create', data);
  },

  // 会场收品-会场收品-取消对活动的关注【分组相关+收藏相关】
  async fetchaActivityWatchCancel(data) {
    return await requestFormPost('/generic/mac/activity/watch/cancel', data);
  },

  /* ****************活动复制相关**************** */
  // 会场收品-会场收品-活动复制【活动复制相关】
  async fetchaActivityCopy(data) {
    return await requestFormPost('/generic/mac/activity/copy', data);
  },
};
